import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-activity-comment-icon',
  template: `
    @if (tooltip) {
      <bl-frontend-tooltip [content]="tooltip">
        <bl-frontend-icon
          name="edit"
          color="warning"
          [ariaLabel]="tooltip"
          [ngClass]="classIfVisible"></bl-frontend-icon>
        <!-- <bl-frontend-badge icon="edit" text=""></bl-frontend-badge> -->
      </bl-frontend-tooltip>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'cursor-pointer' },
})
export class ActivityCommentIconComponent {
  @Input() tooltip: string;
  @Input() classIfVisible: string;
}
